import { render, staticRenderFns } from "./NotificationDrawer.vue?vue&type=template&id=e820ae74&scoped=true"
import script from "./NotificationDrawer.vue?vue&type=script&lang=ts"
export * from "./NotificationDrawer.vue?vue&type=script&lang=ts"
import style0 from "./NotificationDrawer.vue?vue&type=style&index=0&id=e820ae74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e820ae74",
  null
  
)

export default component.exports